module.exports = __webpack_public_path__ + "img/front-panel.8250a60f.png";